import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

/**
 * Hook para configurar Capacitor en plataformas nativas
 * - Status Bar: amarillo (#fef3c7) con iconos azules oscuros
 * - Navigation Bar (Android): gris oscuro (#374151) con iconos blancos
 */
export function useCapacitorConfig() {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) {
      return; // Solo ejecutar en plataformas nativas
    }

    const configureNativeBars = async () => {
      // Delay configuration until after the splash screen is fully gone (1500ms + 500ms fade out)
      await new Promise(resolve => setTimeout(resolve, 2000));
      try {
        // Status Bar: fondo amarillo con iconos oscuros
        await StatusBar.setBackgroundColor({ color: '#fef3c7' });
        await StatusBar.setStyle({ style: Style.Light }); // Iconos oscuros para fondo claro
        await StatusBar.setOverlaysWebView({ overlay: false });
        await StatusBar.show(); // Asegurar que la barra se muestre después del splash

        // Navigation Bar (Android): oscura con botones blancos
        if (Capacitor.getPlatform() === 'android') {
          // Actualizar meta theme-color para navigation bar (oscuro)
          const metaThemeColor = document.querySelector('meta[name="theme-color"]');
          if (metaThemeColor) {
            metaThemeColor.setAttribute('content', '#1f2937'); // gray-800 - más oscuro
          } else {
            const meta = document.createElement('meta');
            meta.name = 'theme-color';
            meta.content = '#1f2937'; // gray-800 - más oscuro
            document.head.appendChild(meta);
          }
        }
      } catch (error) {
        console.warn('Error configurando barras nativas:', error);
      }
    };

    configureNativeBars();
  }, []);
}
